import Footer from "../components/Footer";

export default function Faq() {
  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1 p-6">
        <h1 className="text-2xl font-bold">FAQ</h1>
        <div className="mt-4 space-y-3 max-w-3xl">
          {[{
            q: "Comment sont déduits les crédits ?",
            a: "Chaque étape de génération consomme 1 crédit. Les crédits sont remboursés si l’étape est déjà générée, verrouillée ou en cas d’échec technique.",
          },{
            q: "Puis‑je forcer une régénération ?",
            a: "Oui, via le bouton ‘Forcer tout’ ou en régénérant l’étape depuis son onglet.",
          },{
            q: "Que fait le Copilot ?",
            a: "Il détecte des améliorations (meta, H1, lisibilité) et propose des corrections applicables avec aperçu du diff.",
          },{
            q: "Comment publier ?",
            a: "Depuis l’onglet Publication: export Markdown, copie HTML, ou intégration CMS à venir.",
          }].map((item) => (
            <div key={item.q} className="rounded border p-3">
              <div className="font-medium">{item.q}</div>
              <div className="mt-1 text-sm text-text">{item.a}</div>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
